import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';
import { tooltipHoverTexts } from 'core/helpers/constants';

const GeorgiaAutoLimits = ({ id, disabled, UMBIOptions, UMPDOptions }) => {
  return (
    <>
      <Grid item xs={6}>
        <LabelTooltip
          label="Uninsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMBI`}
            id={`${id}.policyLimitUMBI`}
            type="select"
            options={UMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>
      <Grid item xs={6}>
        <LabelTooltip
          label="Uninsured Motorist PD"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimPropertyDamage }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMPD`}
            id={`${id}.policyLimitUMPD`}
            type="select"
            options={UMPDOptions}
            optional
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>
    </>
  );
};

GeorgiaAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired,
  UMPDOptions: PropTypes.array.isRequired
};

GeorgiaAutoLimits.defaultProps = {
  disabled: false
};

export default connect(GeorgiaAutoLimits);
